import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import FeedbackReportStore from 'stores/Report/Feedback/FeedbackReportStore';
import FeedbackReportForm from 'stores/Forms/Reports/Feedback/FeedbackReportForm';
import { getFormattedDate } from 'helpers/datetime';

import Spinner from 'components/Spinner/Spinner';
import PrintHeader from 'components/Print/Header/PrintHeader';

import ReportTable from './ReportTable';
import FeedbackForm from './FeedbackForm';
import style from './FeedbackReportTab.module.scss';

@observer
class FeedbackReportTab extends Component {
  store = new FeedbackReportStore();
  form = new FeedbackReportForm();

  async componentDidMount() {
    await this.store.getReport(this.form.requestParams);
  }

  render() {
    const { report } = this.store;

    return (
      <section className={style.main}>
        {this.store.loading && <Spinner contain />}

        <PrintHeader
          title={<FormattedMessage id="title.report.feedback.tab1" />}
          description={this.printDescription}
        />

        <FeedbackForm form={this.form} store={this.store} />

        <ReportTable
          report={report}
          tableStyle={style.table__single}
          store={this.store}
        />
      </section>
    );
  }

  get printDescription() {
    const { period } = this.form;
    const from = getFormattedDate(period[0].toISODate());
    const to = getFormattedDate(period[1].toISODate());

    if (from === to) return from;

    return `${from} - ${to}`;
  }
}

export default FeedbackReportTab;
